import React from "react";
import "./ParagraphStyle.css";

function Paragraph() {
  return (
    <div className="paragraph-container">
      <h1>A bit about myself!</h1>
      <p>
        Welcome to my web page! My name is Luis, and I'm a computer programmer
        who recently graduated from Niagara College. I have a strong passion for
        programming and have gained valuable experience working with various
        front and back end frameworks, including React and FastAPI. <br />{" "}
        <br />
        Throughout my academic and professional career, I have honed my skills
        in designing and implementing complex software solutions that meet the
        needs of clients and users. My expertise includes working with
        databases, APIs, and UI/UX design, among other things. <br /> <br />
        I am always seeking out new and challenging experiences that allow me to
        push my skills to the limit and expand my expertise. As a result, I'm
        currently looking for exciting opportunities where I can contribute my
        passion for programming and make a real impact. <br /> <br />
        Whether you're interested in learning more about my programming
        experience or looking for a talented programmer to join your team, I
        invite you to explore my web page and get in touch with me to discuss
        potential opportunities. Thank you for your interest, and I look forward
        to connecting with you soon!
      </p>
      <br />
      <h1>Skills</h1>
      <p>
        I have gained valuable skills in designing and developing software
        solutions that meet the needs of clients and users. My expertise
        includes working with various programming languages and frameworks,
        implementing database structures, creating APIs, and designing UI/UX
        interfaces. I'm always looking for opportunities to expand my knowledge
        and take on new challenges to enhance my programming skills. Here are
        some of them:
      </p>
    </div>
  );
}

export default Paragraph;
